// OPS Occult Library comparative visual archive v4 — Abracadabra source pack.
(()=>{
  const TITLE='abracadabra';
  const SOURCES=[
    {
      date:'6th–7th century',
      period:'Merovingian / early medieval',
      creator:'Unknown maker; photograph by Cangadoba',
      work:'Niello-silver talisman cross with magical signs and a formula related to Abracadabra',
      page:'Object photograph; accession number is not stated on the Commons record',
      institution:'Musée de Cluny / Musée national du Moyen Âge, Paris — “Les temps mérovingiens” exhibition context',
      collection:'Merovingian-period silver talisman cross; display/ownership details beyond the exhibition context are not stated on the source record',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Cluny_-_Mero_-_Croix-Talisman_motifs_magiques_bas%C3%A9_sur_Abracadabra_-_VIe-VII_si%C3%A8cle-_Ag_niell%C3%A9.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Cluny_-_Mero_-_Croix-Talisman_motifs_magiques_bas%C3%A9_sur_Abracadabra_-_VIe-VII_si%C3%A8cle-_Ag_niell%C3%A9.jpg',
      rights:'Creative Commons Attribution-ShareAlike 4.0 International (CC BY-SA 4.0) for the photograph',
      rightsUrl:'https://creativecommons.org/licenses/by-sa/4.0/',
      attribution:'Merovingian niello-silver talisman cross, 6th–7th century, photographed in the Musée de Cluny “Les temps mérovingiens” exhibition by Cangadoba. CC BY-SA 4.0.',
      medium:'Inscribed silver talisman cross',
      technique:'Silver metalwork with niello decoration',
      material:'Silver with niello',
      colour:'Metallic silver and dark niello; colour object photograph',
      visualCharacter:'A small cross-shaped object carries compact linear signs and dark niello-filled marks across the silver surface. The writing and symbols are physically embedded into wearable metalwork rather than presented as a free-standing diagram on paper.',
      note:'The source record describes the inscription as very close to Abracadabra rather than the exact later spelling. It is included as comparative evidence for the wider shrinking-word / protective-formula tradition, not as the earliest surviving ABRACADABRA triangle.'
    },
    {
      date:'c. 1777–1877',
      period:'Late 18th to 19th century manuscript tradition',
      creator:'Unknown Yiddish manuscript hands',
      work:'Hebrew MS 19 — prescriptions for charms and amulets including Abracadabra',
      page:'pp. 22–23; the Commons captions disagree on which facing page contains the Abracadabra prescription',
      institution:'Wellcome Collection, London',
      collection:'MS Hebrew 19; image L0023928; collection of 206 prescriptions, magical charms, folk medicine and nursery rhymes',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Hebrew_MS_19_Wellcome_L0023928.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Hebrew_MS_19_Wellcome_L0023928.jpg',
      rights:'Creative Commons Attribution 4.0 International (CC BY 4.0)',
      rightsUrl:'https://creativecommons.org/licenses/by/4.0/',
      attribution:'Hebrew MS 19, Abracadabra charm prescription, c. 1777–1877, Wellcome Collection, London, image L0023928. CC BY 4.0.',
      medium:'Handwritten charm and remedy manuscript',
      technique:'Manuscript writing by hand; exact ink formulation is not stated in the cited record',
      material:'Ink on paper',
      colour:'Predominantly monochrome manuscript writing in the digitised image',
      visualCharacter:'Dense handwritten lines fill the facing pages with an irregular working-manuscript rhythm. The charm sits inside a practical collection of prescriptions rather than being isolated as decorative occult typography.',
      note:'This is the strongest manuscript source in the pack: Abracadabra remains part of practical charm and folk-medicine writing rather than a theatrical stage word.'
    },
    {
      date:'1904',
      period:'Early 20th-century reference publishing',
      creator:'Anonymous Nordisk familjebok illustrator / editor',
      work:'Abrakadabra — triangular charm diagram in Nordisk familjebok, Uggleupplagan',
      page:'Vol. 1, pp. 57–58 (A–Armati)',
      institution:'Project Runeberg digital facsimile; reproduction hosted by Wikimedia Commons',
      collection:'Nordisk familjebok, Uggleupplagan, vol. 1 (1904)',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Abrakadabra%2C_Nordisk_familjebok.png?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Abrakadabra,_Nordisk_familjebok.png',
      rights:'Public domain; anonymous historical encyclopedia image with expired copyright',
      rightsUrl:'https://commons.wikimedia.org/wiki/File:Abrakadabra,_Nordisk_familjebok.png#Licensing',
      attribution:'Abrakadabra diagram, Nordisk familjebok, Uggleupplagan, vol. 1, 1904, pp. 57–58. Public-domain scan via Project Runeberg / Wikimedia Commons.',
      medium:'Encyclopedia diagram / typographic charm reproduction',
      technique:'Printed typographic line diagram',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visualCharacter:'The word is reduced line by line into a compact triangular block. Uniform type and clean spacing remove the irregularity of handwriting, presenting the charm as a historical reference diagram that can be compared directly with manuscript and object forms.',
      note:'By 1904 the triangular form has moved into encyclopedia illustration: the same typographic structure is documented as a historical fever amulet while the word is already being explained as meaningless magical speech.'
    }
  ];

  const key=(value)=>String(value||'').trim().toLowerCase();
  const nudgeRenderer=()=>{
    const target=document.querySelector('[data-library-reader]');
    if(!target) return;
    const marker=document.createComment('ops-visual-archive-v4-ready');
    target.appendChild(marker);
    marker.remove();
  };
  const install=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    const entry=pack.entries.find((item)=>key(item&&item.title)===TITLE);
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    nudgeRenderer();
    return true;
  };
  if(!install()) document.addEventListener('DOMContentLoaded',install,{once:true});
})();
